(ns frontend.view.components.power-search.recent.view
  (:require
   [ui.util :as uu]
   [common.entity :as entity]
   [common.schema.entity-type-names :as entity-type-names]
   [reagent.core :as r]
   [clojure.string :as string]
   [re-frame.core :as rf]
   [frontend.view.components.power-search.event :as event]
   [ui.components.button.view :as button]))

(defn recent
  [props]
  (let [hovering-state (r/atom false)
        focused-state (r/atom false)]
    (fn [{:keys [result search-query tab-index on-remove active?]}]
      (let [focused? @focused-state
            hovering? @hovering-state]
        [:button
         {:id             (string/join "_"
                                       ["universal-search-result-recent"
                                        (-> result
                                            :entity/type
                                            (str)
                                            (subs 1)) (:db/id result)])
          :class          (uu/cm "m-0 p-1.5 flex gap-2 items-center max-w-[640px] relative hover:text-base-light-text-accent text-sm rounded"
                                 (when active? "bg-base-regular"))
          :tab-index      tab-index
          :on-focus       (fn [] (reset! focused-state true))
          :on-blur        (fn [] (reset! focused-state false))
          :on-key-down    (fn [e] (when (= "Enter" (.-key e)) (.stopPropagation e)))
          :on-mouse-over  #(reset! hovering-state true)
          :on-mouse-leave #(reset! hovering-state false)
          :on-click       (fn []
                            (if search-query
                              (rf/dispatch [::event/select-recent-search search-query])
                              (rf/dispatch [::event/select-recent-result (:entity/type result)
                                            (:db/id result)])))}
         (when result
           [:span 
            {:class "min-w-6 h-6 inline-flex justify-center items-center rounded-full bg-complement-regular"}
            [:i
             {:class (->> result
                          :entity/type
                          (entity/entity-type-icon)
                          (uu/cm "w-4 text-base-light-text" :fal))}]])
         [:div
          {:class "w-full flex flex-col items-start justify-start"}
          [:div 
           {:class "text-base-light-text-paler"}
           (->> result
                :entity/type
                (get entity-type-names/entities)
                :field/translations
                :en)]
          [:div 
           {:class "text-left font-semibold"}
           (or search-query (:title result))]]
         [:div 
          {:class "*:p-0"}
          [button/secondary-open
           {:on-click (fn [event]
                        (.stopPropagation event)
                        (on-remove))}
           [:i.fal.fa-times]]]]))))
